import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "dynamic-background" }, null, -1)
const _hoisted_2 = { class: "ui-btn__icon" }
const _hoisted_3 = {
  key: 0,
  class: "lsi lsi-chevron-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["ui-btn", [_ctx.getClasses(), {
      'ui-btn--disabled': _ctx.disabled,
    }]]),
    style: _normalizeStyle({'background': `${_ctx.background} !important`}),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', $event)))
  }, [
    _hoisted_1,
    _createElementVNode("span", null, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.defaultIcon)
        ? (_openBlock(), _createElementBlock("i", _hoisted_3))
        : _createCommentVNode("", true)
    ])
  ], 6))
}